import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Loader } from "@delibrandev/utils";
import { setLoading } from "../../reducers/userConfigSlice";

export const LoaderComponent = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.aplicationConfig.userConfig.loading);

  useEffect(() => {
    let timeoutId;

    if (loading) {
      // ⏳ Si loading sigue true durante 5 s, lo forzamos a false
      timeoutId = setTimeout(() => {
        console.log("⚠️ Loader activo más de 5 s, se fuerza cierre automático.");
        dispatch(setLoading(false));
      }, 5000);
    }

    // Limpieza al desmontar o cuando loading cambie
    return () => clearTimeout(timeoutId);
  }, [loading, dispatch]);

  return <Loader state={loading} />;
};
